import gsap from "gsap";
import "./lenis";
import "./textAnim";

export function initAnimations() {
    gsap.from("body", {
        opacity: 0,
        duration: 0.9,
        ease: "sine.inOut",
    });
}

jQuery(function ($) {
    try {
        // initAnimations();
    } catch (e) {
        console.error("GSAP animations failed:", e);
    }
});
